CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
{ SavedSearch } = require 'app/scripts/models/SavedSearch'
Util = require 'app/scripts/lib/util'

class SavedSearchList extends CollectionWithHelpers
  model: SavedSearch
  url: -> "/1/member/#{ @member.id }/savedSearches"

  initialize: (list, { @member }) ->
    @listenTo @, 'change:pos', @sort

  comparator: (savedSearch) -> savedSearch.get('pos') || 0

  saveSearch: (name, query) ->
    if @length
      pos = @at(@length - 1).get('pos') + Util.spacing
    else
      pos = Util.spacing

    @create
      name: name
      query: query
      pos: pos
    , { @modelCache }

module.exports = SavedSearchList
